.sn-troubleshooting {
  &__left {
    display: flex;
    flex-direction: column;

    @include above($breakpoint-desktop-md) {
      max-width: 396px;
      flex-shrink: 0;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__accordion {
    border-bottom: 1px solid var(--border-color-tertiary);
    opacity: 0.5;
    transition: opacity 0.25s ease;

    &:hover,
    &--open {
      opacity: 1;
    }
  }

  &__list {
    width: 100%;
  }

  // Wraps the trigger button so each FAQ question is a real <h3> for SEO,
  // while staying visually neutral (no heading sizing/margin).
  &__question {
    margin: 0;
    font: inherit;
    color: inherit;
  }

  &__trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: map-get($spacings, lg) 0;
    background: none;
    border: none;
    cursor: pointer;
    font-weight: 700;
    font-size: map-get($font-sizes, sm);
    line-height: map-get($line-heights, md);
    color: var(--color-text-primary);
    text-align: left;
    gap: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, md);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, lg);
      line-height: map-get($line-heights, lg);
    }
  }

  &__icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    background-image: linear-gradient(currentcolor, currentcolor),
      linear-gradient(currentcolor, currentcolor);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100% 2px, 2px 100%;
    transition: transform 0.3s ease, background-size 0.3s ease;
    pointer-events: none;
  }

  &__accordion--open &__icon {
    background-size: 100% 2px, 2px 0;
    transform: rotate(180deg);
  }

  &__panel {
    padding-bottom: map-get($spacings, lg);
  }

  &__panel-text {
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    margin: 0;

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
